// RESILIENT — PDP v3: variantes + carrito + qty + "Encuentra tu talla".
(function () {
  const root = document.querySelector('.rp3');
  if (!root) return;

  // Galeria slider: miniatura -> desliza el slider; y actualiza la miniatura activa al deslizar
  (function () {
    const gslider = root.querySelector('[data-rp3-gslider]');
    const gthumbs = root.querySelectorAll('[data-rp3-gthumb]');
    if (!gslider || !gthumbs.length) return;
    gthumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        const i = parseInt(t.dataset.rp3Gthumb, 10) || 0;
        gslider.scrollTo({ left: i * gslider.clientWidth, behavior: 'smooth' });
      });
    });
    let raf = null;
    gslider.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        const i = Math.round(gslider.scrollLeft / gslider.clientWidth);
        gthumbs.forEach(function (t, idx) { t.classList.toggle('is-on', idx === i); });
      });
    }, { passive: true });
  })();

  let variants = [];
  try {
    variants = JSON.parse(document.querySelector('[data-rp3-variants]').textContent);
  } catch (e) {}

  const form = document.getElementById('rp3-form');
  const vidInput = root.querySelector('[data-rp3-vid]');
  const priceEl = root.querySelector('[data-rp3-price]');
  const addPriceEl = root.querySelector('[data-rp3-add-price]');
  const addLabel = root.querySelector('[data-rp3-add-label]');
  const colorName = root.querySelector('[data-rp3-color-name]');

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-MX');
  }

  function selectedOptions() {
    const map = {};
    root.querySelectorAll('[data-rp3-opt]:checked').forEach((i) => {
      map[i.getAttribute('data-rp3-optname')] = i.value;
    });
    return map;
  }

  function findVariant() {
    const sel = selectedOptions();
    return variants.find((v) => {
      return (v.options || []).every((optVal, idx) => {
        // match by option value against any selected value
        return Object.values(sel).includes(optVal);
      }) && Object.keys(sel).length > 0
        ? matchExact(v, sel)
        : false;
    });
  }

  function matchExact(v, sel) {
    // v.options is array of option values in order; compare to selected by title
    const wanted = Object.values(sel);
    const have = v.options || [];
    return wanted.length > 0 && wanted.every((w) => have.includes(w));
  }

  function update() {
    const v = variants.find((vr) => matchExact(vr, selectedOptions()));
    if (colorName) {
      const sel = selectedOptions();
      const cName = Object.keys(sel).find((k) => /color/i.test(k));
      if (cName) colorName.textContent = sel[cName];
    }
    // swatch is-on
    root.querySelectorAll('.rp3__swatch').forEach((s) => {
      const inp = s.querySelector('input');
      s.classList.toggle('is-on', !!(inp && inp.checked));
    });
    if (v) {
      if (vidInput) vidInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addPriceEl) addPriceEl.textContent = money(v.price);
      const add = root.querySelector('[data-rp3-add]');
      if (add) add.disabled = false;
      if (addLabel) addLabel.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
    }
  }

  root.querySelectorAll('[data-rp3-opt]').forEach((i) => i.addEventListener('change', update));
  update();

  // Qty
  const qty = root.querySelector('[data-rp3-qty]');
  const clamp = (n) => Math.max(1, Math.min(9, n));
  const dec = root.querySelector('[data-rp3-dec]');
  const inc = root.querySelector('[data-rp3-inc]');
  if (dec) dec.addEventListener('click', () => { qty.value = clamp(parseInt(qty.value, 10) - 1); });
  if (inc) inc.addEventListener('click', () => { qty.value = clamp(parseInt(qty.value, 10) + 1); });

  // ---- Encuentra tu talla ----
  const ff = document.querySelector('[data-rp3-fit]');
  if (ff) {
    const sizes = (ff.getAttribute('data-sizes') || '').split(',').map((s) => s.trim()).filter(Boolean);
    const wIn = ff.querySelector('[data-rp3-weight]');
    const hIn = ff.querySelector('[data-rp3-height]');
    const wOut = ff.querySelector('[data-rp3-w-out]');
    const hOut = ff.querySelector('[data-rp3-h-out]');
    const recEl = ff.querySelector('[data-rp3-rec]');
    const rec2El = ff.querySelector('[data-rp3-rec2]');
    const chipsEl = ff.querySelector('[data-rp3-chips]');
    const suggestEl = root.querySelector('[data-rp3-suggest]');
    let recSize = '';

    const recIndex = (w, h) => {
      let i = w < 55 ? 0 : w < 66 ? 1 : w < 79 ? 2 : w < 91 ? 3 : 4;
      if (h >= 186 && i < 4) i += 1;
      else if (h < 164 && i > 0) i -= 1;
      return i;
    };

    function recompute() {
      const w = Number(wIn.value), h = Number(hIn.value);
      wOut.textContent = w; hOut.textContent = h;
      const bucket = recIndex(w, h);
      const n = sizes.length;
      const pIndex = n === 5 ? bucket : Math.max(0, Math.min(n - 1, Math.round((bucket / 4) * (n - 1))));
      recSize = sizes[pIndex] || '';
      recEl.textContent = recSize;
      if (rec2El) rec2El.textContent = recSize;
      if (suggestEl) suggestEl.textContent = recSize || '—';
      chipsEl.innerHTML = sizes.map((s) => `<span class="rp3ff__chip${s === recSize ? ' is-on' : ''}">${s}</span>`).join('');
    }

    const open = () => { ff.hidden = false; document.body.style.overflow = 'hidden'; recompute(); };
    const close = () => { ff.hidden = true; document.body.style.overflow = ''; };

    root.querySelectorAll('[data-rp3-fit-open]').forEach((b) => b.addEventListener('click', open));
    ff.querySelector('[data-rp3-fit-close]').addEventListener('click', close);
    ff.addEventListener('click', (e) => { if (e.target === ff) close(); });
    wIn.addEventListener('input', recompute);
    hIn.addEventListener('input', recompute);
    ff.querySelector('[data-rp3-fit-apply]').addEventListener('click', () => {
      if (recSize) {
        const input = root.querySelector(`[data-rp3-size][value="${CSS.escape(recSize)}"]`);
        if (input && !input.disabled) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      close();
    });
    recompute();
  }
})();
